const React = require("react")
const ExpiryDate = ({ ...props }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      fill="#0A645A"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.4 1C7.4 0.447715 6.95228 0 6.4 0C5.84771 0 5.4 0.447715 5.4 1V2H4.6C2.07124 2 0 4.02792 0 6.55556V8V15.4444C0 17.9721 2.07124 20 4.6 20H15.4C17.9288 20 20 17.9721 20 15.4444V8V6.55556C20 4.02792 17.9288 2 15.4 2H14.6V1C14.6 0.447715 14.1523 0 13.6 0C13.0477 0 12.6 0.447715 12.6 1V2H7.4V1ZM5.4 4V4.5C5.4 5.05228 5.84771 5.5 6.4 5.5C6.95228 5.5 7.4 5.05228 7.4 4.5V4H12.6V4.5C12.6 5.05228 13.0477 5.5 13.6 5.5C14.1523 5.5 14.6 5.05228 14.6 4.5V4H15.4C16.8477 4 18 5.15584 18 6.55556V7H2V6.55556C2 5.15584 3.15231 4 4.6 4H5.4ZM2 9V15.4444C2 16.8442 3.15231 18 4.6 18H15.4C16.8477 18 18 16.8442 18 15.4444V9H2ZM6 11C6 11.5523 5.55228 12 5 12C4.44772 12 4 11.5523 4 11C4 10.4477 4.44772 10 5 10C5.55228 10 6 10.4477 6 11ZM5 16C5.55228 16 6 15.5523 6 15C6 14.4477 5.55228 14 5 14C4.44772 14 4 14.4477 4 15C4 15.5523 4.44772 16 5 16ZM11 11C11 11.5523 10.5523 12 10 12C9.44771 12 9 11.5523 9 11C9 10.4477 9.44771 10 10 10C10.5523 10 11 10.4477 11 11ZM10 16C10.5523 16 11 15.5523 11 15C11 14.4477 10.5523 14 10 14C9.44771 14 9 14.4477 9 15C9 15.5523 9.44771 16 10 16ZM16 11C16 11.5523 15.5523 12 15 12C14.4477 12 14 11.5523 14 11C14 10.4477 14.4477 10 15 10C15.5523 10 16 10.4477 16 11ZM15 16C15.5523 16 16 15.5523 16 15C16 14.4477 15.5523 14 15 14C14.4477 14 14 14.4477 14 15C14 15.5523 14.4477 16 15 16Z"
      />
    </svg>
  )
}

module.exports = {
  ExpiryDate
}



// WEBPACK FOOTER //
// ./src/shared/skin/icons/iconlink/icons/expiry-date.js